import { 
  SERVICES_GET_OFFICE_INFO,
  SERVICES_GET_OFFICE_STATS,
  SERVICES_GET_SERVICES, 
  SERVICES_SINGLE_OFFICE_INIT,
  PENDING, FULFILLED, REJECTED 
} from '../globals';


export const initialState = {
  servicesData: {
    isLoading: false,
    status: false,
    error: false,
    data: [],
    groups: null,
    errorMessage: [],
  },
  officeData: {
    isLoading: false,
    status: false,
    error: false,
    data: [],
    errorMessage: [],
  },
  statsData: {
    isLoading: false,
    status: false,
    error: false,
    data: [],
    errorMessage: [],
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${SERVICES_SINGLE_OFFICE_INIT}_${PENDING}`:
      return {
        ...initialState,
        servicesData: {
          ...state.servicesData,
          isLoading: true,
        }
      };

    // dont need to proc
    /*case `${SERVICES_SINGLE_OFFICE_INIT}_${FULFILLED}`:
      return {
      };*/

    case `${SERVICES_SINGLE_OFFICE_INIT}_${REJECTED}`: 
      return {
        ...state,
        servicesData: {
          ...state.servicesData,
          isLoading: false,
          status: false,
          error: true,
        }
      };



    case `${SERVICES_GET_SERVICES}_${PENDING}`:
      return {
        ...initialState,
        servicesData: {
          ...state.servicesData,
          isLoading: true,
        }
      };

    case `${SERVICES_GET_SERVICES}_${FULFILLED}`:
      return {
        ...state,
        servicesData: {
          ...state.servicesData,
          isLoading: false,
          status: action.payload.status,
          data: action.payload.data.data,
          groups: action.payload.data.groups,
        }
      };

    case `${SERVICES_GET_SERVICES}_${REJECTED}`: 
      return {
        ...state,
        servicesData: {
          ...state.servicesData,
          isLoading: false,
          status: false,
          error: true,
          errorMessage: action.payload.error,
        }
      };



    case `${SERVICES_GET_OFFICE_INFO}_${PENDING}`:
      return {
        ...state,
        officeData: {
          ...state.officeData,
          isLoading: true,
        }
      };

    case `${SERVICES_GET_OFFICE_INFO}_${FULFILLED}`:
      return {
        ...state,
        officeData: {
          ...state.officeData,
          isLoading: false,
          status: action.payload.status,
          data: action.payload.data,
        }
      };

    case `${SERVICES_GET_OFFICE_INFO}_${REJECTED}`: 
      return {
        ...state,
        officeData: {
          ...state.officeData,
          isLoading: false,
          status: false,
          error: true,
          errorMessage: action.payload.error,
        }
      };
    

    
    case `${SERVICES_GET_OFFICE_STATS}_${PENDING}`:
      return {
        ...state,
        statsData: {
          ...state.statsData,
          isLoading: true,
        }
      };

    case `${SERVICES_GET_OFFICE_STATS}_${FULFILLED}`:
      return {
        ...state,
        statsData: {
          ...state.statsData,
          isLoading: false,
          status: action.payload.status,
          data: action.payload.data,
        }
      };

    case `${SERVICES_GET_OFFICE_STATS}_${REJECTED}`: 
      return {
        ...state,
        statsData: {
          ...state.statsData,
          isLoading: false,
          status: false,
          error: true,
          errorMessage: action.payload.error,
        }
      };
    
    default:
      return state;
  }
};

export default reducer;
